module.exports = __webpack_public_path__ + "media/images/forest_poster-ea47e0c532ec6452da5a383975aeb15d.png";